<template>
    <div>
        <div id="quote" :style="'border-color: ' + this.color">
            <p id="quote-text">{{ '"' + quote + '"'}}<br/><i id="author">— {{ author }}</i></p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        quote: String,
        author: String,
        color: String
    },
            // document.getElementById("title").style.display = "none";
            // // document.getElementById("title").style.opacity = "0";
            // var element = document.getElementById("title");
            // element.style.left = this.title.left;
            // element.style.top = this.title.top;
            // element.style.fontSize = this.title.fontSize;
            // document.getElementById("title").style.display="block"
            // document.getElementById("title").style.opacity = "1";
}
</script>

<style scoped>
    #quote {
        background-color: #303030;
        border-bottom: 2px solid;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 15vh;
    }
    #quote-text {
        font-size: 20px;
        color: #ebebeb;
        padding: 20px;
        width: 60vh;
        margin-bottom: 0px;
    }
    #author {
        font-weight: 400;
    }
        @keyframes fadein {
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
    }
    @-moz-keyframes fadein { /* Firefox */
        from {
            opacity:0;
        }
        to {
            opacity:1;
        }
    }
    @-webkit-keyframes fadein { /* Safari and Chrome */
        from {
            opacity:0;
        }
        to {
            opacity:1;
        }
    }
    @-o-keyframes fadein { /* Opera */
        from {
            opacity:0;
        }
        to {
            opacity: 1;
        }
    }
</style>